import { Box, Grid, Tab, Tabs } from "@mui/material";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { AgreementDetailsTab } from "./Tabs/AgreementDetailsTab";
import { AgreementDocumentsTab } from "./Tabs/AgreementDocumentsTab";
import { CustomersTab } from "./Tabs/CustomersTab";
import { PaymentsTab } from "./Tabs/PaymentsTab";
import { ProductsTab } from "./Tabs/ProductsTab";
import { AgreementNotificationTab } from "./Tabs/AgreementNotificationTab";
import { useSearchParams } from "react-router-dom";

export const AgreementPassportTabType = {
    CUSTOMERS: 0,
    PRODUCTS: 1,
    AGREEMENT_DETAILS: 2,
    PAYMENTS: 3,
    NOTIFICATIONS: 4,
    DOCUMENTS: 5,
};

export const AgreementPassportTabs = (props) => {
    const { agreement, readOnly } = props;
    const { t } = useTranslation();

    const [searchParams] = useSearchParams();
    const initFromPayments = searchParams.get("show_payments_tab")=== "true" ;

    const [selectedTab, setSelectedTab] = useState(initFromPayments? AgreementPassportTabType.PAYMENTS: AgreementPassportTabType.CUSTOMERS);

    const handleTabChange = useCallback(
        (event, newTab) => {
            setSelectedTab(newTab);
        },
        [setSelectedTab],
    );

    return (
        <Grid container direction="column" spacing={2}>
            <Grid item xs={12}>
                <Tabs value={selectedTab} onChange={handleTabChange} centered>
                    <Tab
                        label={t("agreements.AgreementPassportDialog.tabs.customers")}
                        value={AgreementPassportTabType.CUSTOMERS}
                    />
                    <Tab
                        label={t("agreements.AgreementPassportDialog.tabs.products")}
                        value={AgreementPassportTabType.PRODUCTS}
                    />
                    <Tab
                        label={t("agreements.AgreementPassportDialog.tabs.agreementDetails")}
                        value={AgreementPassportTabType.AGREEMENT_DETAILS}
                    />
                    <Tab
                        label={t("agreements.AgreementPassportDialog.tabs.payments")}
                        value={AgreementPassportTabType.PAYMENTS}
                    />
                    <Tab
                        label={t("agreements.AgreementPassportDialog.tabs.notifications")}
                        value={AgreementPassportTabType.NOTIFICATIONS}
                    />
                    <Tab
                        label={t("agreements.AgreementPassportDialog.tabs.documents")}
                        value={AgreementPassportTabType.DOCUMENTS}
                    />
                </Tabs>
            </Grid>
            <Grid item xs={12}>
                <TabPanel activeTab={selectedTab} tab={AgreementPassportTabType.CUSTOMERS}>
                    <CustomersTab
                        customers={agreement.customers}
                        customerShares={agreement.shares}
                        readOnly={props.readOnly}
                    />
                </TabPanel>
                <TabPanel activeTab={selectedTab} tab={AgreementPassportTabType.PRODUCTS}>
                    <ProductsTab products={agreement.products} agreementId={agreement.id} agreementFinalSettlement={agreement.agreement_final_settlement} isInvestmentEffectiveFootageFilled={agreement.is_investment_effective_footage_filled} agreementKind={agreement.agreement_kind.agrekind_key} readOnly={readOnly} />
                </TabPanel>
                <TabPanel activeTab={selectedTab} tab={AgreementPassportTabType.AGREEMENT_DETAILS}>
                    <AgreementDetailsTab agreement={agreement} />
                </TabPanel>
                <TabPanel activeTab={selectedTab} tab={AgreementPassportTabType.PAYMENTS}>
                    <PaymentsTab agreement={agreement} readOnly={readOnly} />
                </TabPanel>
                <TabPanel activeTab={selectedTab} tab={AgreementPassportTabType.NOTIFICATIONS}>
                    <AgreementNotificationTab agreement={agreement} readOnly={readOnly} />
                </TabPanel>
                <TabPanel activeTab={selectedTab} tab={AgreementPassportTabType.DOCUMENTS}>
                    <AgreementDocumentsTab agreement={agreement} readOnly={readOnly} />
                </TabPanel>
            </Grid>
        </Grid>
    );
};

const TabPanel = (props) => {
    const { children, activeTab, tab } = props;

    return activeTab === tab ? <Box>{children}</Box> : null;
};
